import { render, staticRenderFns } from "./paymentDtl.vue?vue&type=template&id=36e08225&scoped=true&"
import script from "./paymentDtl.vue?vue&type=script&lang=js&"
export * from "./paymentDtl.vue?vue&type=script&lang=js&"
import style0 from "./paymentDtl.vue?vue&type=style&index=0&id=36e08225&prod&lang=scss&scoped=true&"
import style1 from "./paymentDtl.vue?vue&type=style&index=1&id=36e08225&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e08225",
  null
  
)

export default component.exports